<template>
<v-autocomplete v-model="model" :items="items" :loading="loading" :search-input.sync="search" flat solo placeholder="Select user" clearable item-value="id" item-text="full_name" :menu-props="{transition:'scale-transition', 'offset-y': ''}"
    hide-details return-object>

    <template v-slot:selection="data">
        <v-row style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:150px" align="center" no-gutters>
            <v-avatar v-if="data.item.avatar" size="21">
                <img :src="data.item.avatar">
            </v-avatar>
            <span :class="{'pl-2':data.item.avatar}">{{data.item.full_name}}</span>
        </v-row>
    </template>

    <template v-slot:item="data">
        <v-card tile flat style="background: transparent;">
            <v-avatar v-if="data.item.avatar" size="21">
                <img :src="data.item.avatar" style="width:21px;height:21px;">
            </v-avatar>
            {{data.item.full_name}}
        </v-card>
    </template>

</v-autocomplete>
</template>

<script>
import defaults from "./PropDefaults.js";

export default {
    props: {
        user: Object,
    },
    data() {
        return {
            model: defaults.user_item,
            items: [],
            loading: false,
            search: null,
            search_timeout: 500,
        }
    },

    watch: {

        search(val) {
            if(this.model && val === this.model.full_name) {
                return;
            }

            clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(this.getItems(val), 300);
        },

        model() {
            this.$emit('input', this.model);
        },

        user(val) {
            this.model = {
                id: val.id,
                full_name: val.full_name,
                type: val.type,
            };
            if(val.id && val.full_name && val.type) {
                this.items = [this.model]
            } else {
                this.items = [];
            }
        },
    },

    methods: {
        getItems(val) {
            // quit early if no search value
            if(!val) {
                return
            }
            // loading
            this.loading = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/users';

            // prepare params
            let options = {
                params: {
                    search: val,
                    fields: ['first_name', 'last_name', 'email'],
                    size: 5
                }
            };

            // make places search request
            this.$axios.get(endpoint, options)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });

        },

        clear() {
            this.model = {};
            this.items = [];
        }

    }

}
</script>
